<template>
    <div>
        <div class="reporting-list">
            <div>
                <div>Hmotnost</div>
                <div
                    v-bind:class="{
                        'negative-number': isPositiveProgress(valueWeight),
                        'positive-number': isPositiveProgress(valueWeight) === false
                    }"
                    class="parameter-number"
                >
                    <div class="status-arrow" v-if="valueWeight !== 0 && valueWeight">
                        <img v-if="isPositiveProgress(valueWeight)" :src="arrows.down" />
                        <img v-else :src="arrows.up" />
                    </div>
                    <div>{{ dotToComma(weight) }} kg</div>
                </div>
            </div>
        </div>
        <div class="reporting-list">
            <div>
                <div>Obvod pasu</div>
                <div
                    v-bind:class="{
                        'negative-number': isPositiveProgress(valueWaist),
                        'positive-number': isPositiveProgress(valueWaist) === false
                    }"
                    class="parameter-number"
                >
                    <div class="status-arrow" v-if="valueWaist !== 0 && valueWaist">
                        <img v-if="isPositiveProgress(valueWaist)" :src="arrows.down" />
                        <img v-else :src="arrows.up" />
                    </div>
                    <div>{{ dotToComma(valueWaist) }} cm</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                arrows: {
                    up: '/imgs/reporting/arrow-up-red.svg',
                    down: '/imgs/reporting/arrow-down-green.svg'
                },
                regionsLocalStorageParsed: [],
                companiesLocalStorageParsed: [],
                fetching: true
            }
        },

        computed: {
            ...mapGetters('reporting', ['weight', 'waist']),

            valueWeight() {
                return this.weight
            },
            valueWaist() {
                return this.waist
            }
        },

        created() {
            this.initialData()

            if (!this.fetching) {
                this.apiPatientValues({
                    countries: this.regionsLocalStorageParsed,
                    institutions: this.companiesLocalStorageParsed
                })
            }
        },

        methods: {
            ...mapActions({
                apiPatientValues: 'reporting/apiPatientValues'
            }),

            dotToComma(number) {
                if (number) {
                    //round number
                    number = Math.round(number * 10) / 10
                    if (number > 0) {
                        number = '+' + number
                    }
                    this.isPositiveProgress()
                    return number.toString().replace('.', ',')
                }
                return 0
            },

            isPositiveProgress(arg) {
                if (arg > 0) {
                    return false
                }

                if (arg < 0) {
                    return true
                }
            },

            initialData() {
                const regionsLocalStorage = window.localStorage.regions

                if (regionsLocalStorage) {
                    this.regionsLocalStorageParsed = JSON.parse(regionsLocalStorage)
                }

                const companiesLocalStorage = window.localStorage.companies

                if (companiesLocalStorage) {
                    this.companiesLocalStorageParsed = JSON.parse(companiesLocalStorage)
                }

                this.fetching = false

                return
            }
        }
    }
</script>
